// Module
var code = "<div id=\"rateentry-lane-rate-component\"> <div id=\"laneRateGrid\"></div> <div data-bind=\"with: uploadRatesModal\"> <rate-batch-lanerate-import-component params=\"rateNumber: rateNumber, editMode: editMode, onSave: $parent.handleBatchUploadSave\"></rate-batch-lanerate-import-component> </div> </div>";
// Exports
export default code;